import Swiper from "swiper/bundle";
import LazyLoad from "vanilla-lazyload";
import Common from "../modules/common";

const Home = {
  init: function () {
    Home.shortVideoSlider();
    Home.playShortSmallVideo();
    Home.favoritesSlider();
    //Home.birdSlider();
    Home.homeProductsSlider();
    Home.infograph();
    Home.infographAccordions();
  },

  shortVideoSlider() {
    const wrapEl = $(".main-hero");
    if (!wrapEl) {
      return
    } else {

      const slideCount = wrapEl.find(".main-hero-item--video-slider .swiper-slide").length;
      const prevEl = wrapEl.find(".swiper-nav-button--prev")[0];
      const nextEl = wrapEl.find(".swiper-nav-button--next")[0];

      if (slideCount <= 1) {
        prevEl.style.display = "none";
        nextEl.style.display = "none";
      }

      let swiper = new Swiper(wrapEl.find(".main-hero-item--video-slider .swiper")[0],
        {
          initialSlide: 1,
          centeredSlides: true,
          slidesPerView: 1.7,
          loop: false,
          spaceBetween: 16,
          navigation: (slideCount > 1) ? {
            prevEl: prevEl,
            nextEl: nextEl,
          } : "",
          breakpoints: {
            600: {
              slidesPerView: 1,
            }
          }
        })
    }
  },

  playShortSmallVideo() {
    // Video file playing
    const videoWrapEl = $('.short-video-small');
    const video = videoWrapEl.find('video')[0];

    if ((videoWrapEl.length > 0) && video) {

      videoWrapEl.addClass('ready');

      new LazyLoad.load(
        video,
        {
          callback_loaded: function (el) {
            videoWrapEl.addClass('playing');
            el.play();
          }
        }
      );
    }
  },

  favoritesSlider() {
    const wrapElements = document.querySelectorAll(".favorites__slider-wrap");

    wrapElements.forEach(wrapEl => {
      const swiperEl = wrapEl.querySelector(".swiper");
      const slideCount = swiperEl.querySelectorAll(".swiper-slide").length;
      const prevEl = swiperEl.querySelector(".swiper-nav-button--prev");
      const nextEl = swiperEl.querySelector(".swiper-nav-button--next");

      if (slideCount <= 1) {
        if (prevEl) prevEl.style.display = "none";
        if (nextEl) nextEl.style.display = "none";
      }

      let swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 26,
        navigation: (slideCount > 1) ? {
          prevEl: prevEl,
          nextEl: nextEl,
        } : undefined,
        breakpoints: {
          600: {
            slidesPerView: "auto",
          }
        },
        on: {
          slideChangeTransitionStart: function() {
            if (Common.lazyLoadInstance) {
              Common.lazyLoadInstance.update();
            }
          }
        }
      });

      const slides = swiperEl.querySelectorAll('.swiper-slide');
      let maxHeight = 0;

      slides.forEach(slide => {
        maxHeight = Math.max(maxHeight, slide.offsetHeight);
      });

      slides.forEach(slide => {
        slide.style.height = `${maxHeight}px`;
      });
    });
  },

  homeProductsSlider() {
    const wrapElements = document.querySelectorAll(".home-products__slider-wrap");

    wrapElements.forEach(wrapEl => {
      const slideCount = wrapEl.querySelectorAll(".swiper .swiper-slide").length;
      const prevEl = wrapEl.querySelector(".swiper-nav-button--prev");
      const nextEl = wrapEl.querySelector(".swiper-nav-button--next");

      if (slideCount <= 1) {
        prevEl.style.display = "none";
        nextEl.style.display = "none";
      }

      let swiper = new Swiper(wrapEl.querySelector(".swiper"), {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 26,
        navigation: (slideCount > 1) ? {
          prevEl: prevEl,
          nextEl: nextEl,
        } : undefined,
        breakpoints: {
          600: {
            slidesPerView: "auto",
          }
        },
        on: {
          slideChangeTransitionStart: function() {
            if (Common.lazyLoadInstance) {
              Common.lazyLoadInstance.update();
            }
          }
        }
      });

      const slides = wrapEl.querySelectorAll('.swiper-slide');
      let maxHeight = 0;

      slides.forEach(slide => {
        maxHeight = Math.max(maxHeight, slide.offsetHeight);
      });

      slides.forEach(slide => {
        slide.style.height = `${maxHeight}px`;
      });
    });
  },

  infograph() {
    document.querySelectorAll(".map-pin").forEach((pin) => {
      const posTop = parseInt(pin.getAttribute("data-pos-top"), 10);
      const posLeft = parseInt(pin.getAttribute("data-pos-left"), 10);

      if (posTop) pin.style.top = `${posTop}%`;
      if (posLeft) pin.style.left = `${posLeft}%`;
    });
  },

  infographAccordions() {
    const accordionGroups = document.querySelectorAll(
      ".infograph .accordion-group"
    );

    accordionGroups.forEach((group) => {
      const accordionItems = group.querySelectorAll(".accordion");

      accordionItems.forEach((item) => {
        const btn = item.querySelector(".accordion__top");

        btn.addEventListener("click", () => {
          accordionItems.forEach((otherItem) => {
            if (otherItem !== item) {
              otherItem.classList.remove("active");
            }
          });

          item.classList.toggle("active");
        });
      });
    });
  }

};

export default Home;
